/*
 * @Author: csu chen.su@murata.com
 * @Date: 2022-06-22 15:36:49
 * @LastEditors: csu chen.su@murata.com
 * @LastEditTime: 2023-08-17 16:26:00
 * @FilePath: \frontend\src\store\modules\system.js
 */
const getDefaultState = () => {
  return {
    time: '',
    gwName: '',
    isShowNotification: false,
    lang: 'en',
    isInit: false,
  };
};

const state = getDefaultState();

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
  SET_GWNAME: (state, gwName) => {
    state.gwName = gwName;
  },
  SET_TIME: (state, time) => {
    state.time = time;
  },
  SET_IS_SHOW_NOTIFICATION: (state, isShowNotification) => {
    state.isShowNotification = isShowNotification;
  },
  SET_LANG: (state, lang) => {
    state.lang = lang;
  },
  SET_ISINIT: (state, isInit) => {
    state.isInit = isInit;
  },
};

const actions = {
  setGwName({ commit }, gwName) {
    commit('SET_GWNAME', gwName);
  },

  setTime({ commit }, time) {
    commit('SET_TIME', time);
  },

  setIsShowNotification({ commit }, isShowNotification) {
    commit('SET_IS_SHOW_NOTIFICATION', isShowNotification);
  },

  setLang({ commit }, lang) {
    commit('SET_LANG', lang);
  },

  setIsInit({ commit }, isInit) {
    commit('SET_ISINIT', isInit);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
